import React from 'react';
import { BatchTransaction_batchTransaction } from '../../../__generated__/BatchTransaction';
import { BatchTransactionAvailableDocumentTypes } from '../../../__generated__/BatchTransactionAvailableDocumentTypes';
import { AttachFormModal } from './AttachFormModal';
import { useFormContext } from 'react-hook-form';

 interface AttachFormProps {
  availableDocumentTypes: BatchTransactionAvailableDocumentTypes | undefined;
  batchTransaction: BatchTransaction_batchTransaction;
}

export const AttachForm: React.FC<AttachFormProps> = ({
  batchTransaction,
  availableDocumentTypes,
}) => {

  const { formState: { isDirty } } = useFormContext();

  return (
   
        <AttachFormModal
          batchTransaction={batchTransaction}
          availableDocumentTypes={availableDocumentTypes}
          isDirty={isDirty}
        />
   
  );
};
